import React, { useState } from 'react';
import { Send, Mail, User, MessageSquare } from 'lucide-react';
import { toast } from 'sonner';

const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validación básica
    if (!formData.name || !formData.email || !formData.message) {
      toast.error('Por favor completa todos los campos requeridos');
      return;
    }

    setIsSubmitting(true);

    try {
      // USAMOS RUTA RELATIVA: Nginx redirigirá /api/contact al puerto 5000 de Flask
      const response = await fetch('/api/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      const result = await response.json();

      if (result.success) {
        toast.success('¡Mensaje enviado con éxito! Nos pondremos en contacto pronto.');
        setFormData({ name: '', email: '', company: '', message: '' });
      } else {
        toast.error('Error del servidor: ' + (result.error || 'Inténtalo de nuevo.'));
      }
    } catch (error) {
      console.error('Error en el envío:', error);
      toast.error('No se pudo conectar con el servidor de correo.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" style={{
      padding: '100px 7.6923%',
      background: '#000000',
      position: 'relative'
    }}>
      <div className="grid-pattern" style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, pointerEvents: 'none' }} />
      <div style={{ maxWidth: '900px', margin: '0 auto', position: 'relative', zIndex: 2 }}>
        <div style={{ textAlign: 'center', marginBottom: '60px' }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '8px 16px', background: 'rgba(0, 255, 209, 0.1)', borderRadius: '0px', marginBottom: '24px' }}>
            <Mail size={16} color="#00FFD1" />
            <span style={{ color: '#00FFD1', fontSize: '14px', fontWeight: 500 }}>CONTACTO</span>
          </div>
          <h2 style={{ fontSize: '48px', fontWeight: 600, lineHeight: 1.1, color: '#FFFFFF', marginBottom: '20px' }}>Comienza tu Transformación Digital</h2>
          <p style={{ fontSize: '20px', color: 'rgba(255, 255, 255, 0.85)', maxWidth: '600px', margin: '0 auto' }}>Contáctanos para una demo personalizada o consulta técnica</p>
        </div>

        <div style={{ background: '#121212', border: '1px solid rgba(255, 255, 255, 0.25)', padding: '60px', maxWidth: '700px', margin: '0 auto' }} className="contact-form-container">
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <label style={{ fontSize: '14px', fontWeight: 500, color: '#FFFFFF', display: 'flex', alignItems: 'center', gap: '8px' }}>
                <User size={16} color="#00FFD1" /> Nombre *
              </label>
              <input type="text" name="name" value={formData.name} onChange={handleChange} required style={{ background: '#000000', border: '1px solid rgba(255, 255, 255, 0.25)', padding: '14px 16px', color: '#FFFFFF', outline: 'none' }} placeholder="Tu nombre" />
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <label style={{ fontSize: '14px', fontWeight: 500, color: '#FFFFFF', display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Mail size={16} color="#00FFD1" /> Email *
              </label>
              <input type="email" name="email" value={formData.email} onChange={handleChange} required style={{ background: '#000000', border: '1px solid rgba(255, 255, 255, 0.25)', padding: '14px 16px', color: '#FFFFFF', outline: 'none' }} placeholder="tu@email.com" />
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <label style={{ fontSize: '14px', fontWeight: 500, color: '#FFFFFF' }}>Empresa (Opcional)</label>
              <input type="text" name="company" value={formData.company} onChange={handleChange} style={{ background: '#000000', border: '1px solid rgba(255, 255, 255, 0.25)', padding: '14px 16px', color: '#FFFFFF', outline: 'none' }} placeholder="Nombre de tu empresa" />
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <label style={{ fontSize: '14px', fontWeight: 500, color: '#FFFFFF', display: 'flex', alignItems: 'center', gap: '8px' }}>
                <MessageSquare size={16} color="#00FFD1" /> Mensaje *
              </label>
              <textarea name="message" value={formData.message} onChange={handleChange} required rows={5} style={{ background: '#000000', border: '1px solid rgba(255, 255, 255, 0.25)', padding: '14px 16px', color: '#FFFFFF', outline: 'none', resize: 'vertical' }} placeholder="Cuéntanos sobre tu proyecto o consulta" />
            </div>

            <button type="submit" className="btn-primary" disabled={isSubmitting} style={{
              marginTop: '16px',
              opacity: isSubmitting ? 0.6 : 1,
              cursor: isSubmitting ? 'not-allowed' : 'pointer',
              background: '#00FFD1',
              color: '#000000',
              padding: '16px',
              border: 'none',
              fontWeight: 'bold',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '10px'
            }}>
              {isSubmitting ? 'Enviando...' : 'Enviar Mensaje'}
              {!isSubmitting && <Send size={20} />}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
